import angular from 'angular';
import TranslateService from '@/shared/services/TranslateService';
import zendesk from '@/zendesk';
import { getZendeskUrl, getMyTicketsUrl } from '@/shared/components/ZendeskHelp';
import userflow from 'userflow.js';
const formatUserflowCulture = (culture, tenantConfiguration) => {
  switch (culture?.toLowerCase()) {
    case 'nl':
    case 'nl-be':
    case 'en-be':
      return 'nl-BE';
    case 'nl-nl':
    case 'en-nl':
      return 'nl-NL';
    case 'fr':
    case 'fr-be':
      return 'fr-BE';
  }
  switch (tenantConfiguration) {
    case 0:
    case 1:
      return 'nl-BE';
    case 3:
      return 'fr-BE';
    case 5:
      return 'nl-NL';
    default:
      return 'nl-BE';
  }
};

angular.module('cloudX').directive('cxMenu', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: require('./menu.html'),
      scope: true,
      controller: [
        '$window',
        '$scope',
        'resourceFactorySvc',
        'loadingAnimationSvc',
        'authService',
        '$translate',
        'tmhDynamicLocale',
        'relBindSvc',
        '$state',
        'dataCache',
        'flySvc',
        'notificationSvc',
        'checkFeature',
        'jobSvc',
        'recentRelationsSvc',
        'insights',
        'appUrls',
        '$http',
        'environment',
        'enumCacheSvc',
        menuCtrl,
      ],
    };

    function menuCtrl(
      $window,
      $scope,
      resourceFactorySvc,
      loadingAnimationSvc,
      authService,
      $translate,
      tmhDynamicLocale,
      relBindSvc,
      $state,
      dataCache,
      flySvc,
      notificationSvc,
      checkFeature,
      jobSvc,
      recentRelationsSvc,
      insightsService,
      appUrls,
      $http,
      environment,
      enumCacheSvc,
    ) {
      $scope.userName = '';
      $scope.notificationSvc = notificationSvc;
      $scope.logOut = authService.logOut;
      $scope.hasEid = checkFeature('Eid');
      $scope.jobSvc = jobSvc;
      $scope.recentRelationsSvc = recentRelationsSvc;
      $scope.connectWebUrl = appUrls.connect;
      $scope.zendeskUrl = 'http://support.adminpulse.be'; //will be replaced by url with culture

      var tenantConfiguration = parseInt(authService.getClaims().TenantConfiguration || '1');

      function init() {
        dataCache.ready().then(function() {
          insightsService.ready().then(() => {
            setupUserflow();
          });

          var auth = authService.getClaims();

          $scope.showPaymentMonitoring = dataCache.showPaymentMonitoring;

          var company = dataCache.getArray('defaultcompany');

          $scope.languages = dataCache.getArray('language');
          $scope.buildNumber = dataCache.getArray('buildNumber');
          $scope.userName = auth.Name;
          $scope.loadingAnimationSvc = loadingAnimationSvc;
          $scope.connectWebUrl = `${appUrls.connect}?companyId=${company.id}`;
          $scope.su = auth.su || 0;
          initLanguage();
        });
      }

      init();

      $scope.setLang = function(code, isInitial) {
        const language = $scope.languages.find(x => x.code === code);
        if (!language) return;
        var originalCode = $translate.use();
        var newCode = language.culture;
        $scope.zendeskUrl = getZendeskUrl(null, newCode);
        $translate.use(newCode).then(() => {
          TranslateService.onLocaleChanged();
          if (
            (!isInitial || originalCode !== newCode) &&
            $state &&
            $state.current &&
            $state.current.isReact
          ) {
            $state.reload();
          }
        });

        $scope.currentLanguage = language;
        tmhDynamicLocale.set(language.culture);
        if (typeof $window.userflow !== 'undefined' && userflow.isIdentified())
          userflow.updateUser({
            language: language.code.toLowerCase(),
            locale_code: formatUserflowCulture(language.culture, tenantConfiguration),
          });
        if (typeof $window.zE !== 'undefined')
          $window.zE('webWidget', 'setLocale', language.code.toLowerCase());

        insightsService.ready().then(() => {
          setupBeamerWhatsNew(language.code);
        });

        if (!isInitial) {
          setEmployeeLanguage(language);
        }
      };

      var initLanguage = function() {
        var employee = dataCache.getArray('employee');
        var lang = (employee.userLanguage || 'en').toLowerCase();
        $scope.setLang(lang, true);
      };

      $scope.openRelation = function(id) {
        relBindSvc.open(id);
      };
      $scope.openConnect = function() {
        $window.open($scope.connectWebUrl, '_blank');
      };

      $scope.createTicket = function() {
        zendesk.createTicket();
      };
      $scope.openMyTickets = () => {
        $window.open(getMyTicketsUrl($translate.use()), '_blank');
      };
      $scope.mobile = function() {
        var windowWidth = $window.innerWidth;
        return windowWidth <= 768;
      };

      const setupBeamerWhatsNew = languageCode => {
        if (typeof Beamer !== 'undefined') {
          try {
            const insights = insightsService.get();
            var employee = dataCache.getArray('employee');

            Beamer.update({
              ...beamer_config, // global variable that was declared in index.js
              user_firstname: employee.firstName,
              user_lastname: employee.lastName,
              filter: insights.segments,
              language: languageCode,
            });
          } catch (error) {
            console.log(error);
          }
        }
      };
      const setupUserflow = () => {
        if (!$window.userflowInitialized) return;
        var auth = authService.getClaims();
        if (auth.su && auth.su === '1') return; // support user

        enumCacheSvc.get('role').then(roles => {
          try {
            const insights = insightsService.get();
            const employee = dataCache.getArray('employee');
            const company = dataCache.getArray('defaultcompany');
            const tenantId = dataCache.getArray('tenantId');
            const tenantCreatedOn = dataCache.getArray('createdOn');
            const userSignature = dataCache.getArray('userflowUserSignature');
            const tenantSignature = dataCache.getArray('userflowTenantSignature');
            const isTrial = dataCache.getArray('isTrial');
            const twoFaRequired = dataCache.getArray('twoFaRequired');
            const [userRole] = employee.userRoles || [];

            const role = roles.find(x => x.key === userRole.role);

            userflow.identify(
              auth.Sid,
              {
                email: auth.Email,
                name: auth.Name,
                signed_up_at: employee.userCreatedOn,
                language: employee.languageCode,
                locale_code: formatUserflowCulture(employee.userCulture, tenantConfiguration),
                segments: insights.segments?.split(';') ?? [],
              },
              {
                signature: userSignature,
              },
            );
            userflow.group(
              auth.GroupSid,
              {
                name: company.name,
                signed_up_at: tenantCreatedOn,
                tenant_configuration: tenantConfiguration,
                is_trial: isTrial,
                is_twofa_required: twoFaRequired,
              },
              {
                signature: tenantSignature,
                membership: {
                  role: userRole.customRoleName && !role ? 'Custom' : role?.value,
                  custom_role: userRole.customRoleName,
                },
              },
            );
          } catch (error) {
            console.log(error);
          }
        });
      };

      function setEmployeeLanguage(language) {
        var resource = resourceFactorySvc.get('user');
        const model = {
          language: language.code,
          culture: language.culture,
        };

        return resource.language(model).$promise.then(
          function(result) {
            var employee = dataCache.getArray('employee');
            if (employee) {
              employee.userLanguage = model.language;
              employee.userCulture = model.culture;
            }
            flySvc.success('msgConfirmChange');
            return false;
          },
          function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return '';
          },
        );
      }
    }
  },
]);
